import { createSlice } from '@reduxjs/toolkit';

/**
 * Build State for actions
 * Demo load data message
 * Author: Oliver.Nguyen
 */
export const DemoSlice = createSlice({
    name: 'demo',
    initialState:{
        loading: false,
        hasErrors: false,
        message: []
    },
    reducers: {
      demoLoading: state => {
        // Redux Toolkit allows us to write "mutating" logic in reducers. It
        // doesn't actually mutate the state because it uses the Immer library,
        // which detects changes to a "draft state" and produces a brand new
        // immutable state based off those changes
        state.loading = true;

      },
      demoLoadedSuccess: (state, { payload }) => {
        state.message = payload
        state.loading = false
        state.hasErrors = false
      },
      demoLoadedError: state => {
        state.loading = false
        state.hasErrors = true
      }
    },
  });
  
  // export const { load, loadSuccess, loadError } = DemoSlice.actions;

  // export const selectMessage = state => state.announcement.message;

  export default DemoSlice.reducer;


// WEBPACK FOOTER //
// ./src/app/slices/DemoSlice.js